var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3834 22.0879L10.6164 22.0879C8.50449 22.0879 6.79248 23.7999 6.79248 25.9118L6.79248 39.2953C6.79248 41.4072 8.50449 43.1192 10.6164 43.1192L37.3834 43.1192C39.4953 43.1192 41.2073 41.4072 41.2073 39.2953L41.2073 25.9118C41.2073 23.7999 39.4953 22.0879 37.3834 22.0879Z",
    fill: "url(#paint0_linear_15402_8517)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4399 22.0883L14.4399 14.4405C14.4399 11.9052 15.4471 9.47361 17.2399 7.68082C19.0327 5.88804 21.4642 4.88086 23.9996 4.88086C26.535 4.88086 28.9665 5.88804 30.7593 7.68082C32.5521 9.47361 33.5593 11.9052 33.5593 14.4405L33.5593 22.0883",
    stroke: "#8E8CEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15402_8517",
    x1: 29.3446,
    y1: 22.0879,
    x2: 19.1261,
    y2: 53.0528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.448928,
    stopColor: "#D0CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449028,
    stopColor: "#BAB9FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.53acdc875b7a45a4ca8cd00f09938032.svg";
export { ForwardRef as ReactComponent };